export const fileHistoryConstants = {
  MaxRows: 10,
  OptypeDescPrefixes: {
    rename: 'rename',
    copy: 'copy',
    move: 'move',
  },
  TimestampOffsets: [
    { label: '1D', tooltip: '1 Day', value: 1, localizeId: 'day' },
    { label: '1W', tooltip: '1 Week', value: 7, localizeId: 'week' },
    { label: '1M', tooltip: '1 Month', value: 30, localizeId: 'month' },
    { label: '1Y', tooltip: '1 Year', value: 365, localizeId: 'year' },
  ],
  TableHeadings: [
    {
      label: 'File',
      key: 'fileName',
      localizeId: 'file',
    },
    {
      label: 'Operation',
      key: 'optype',
      localizeId: 'operation',
    },
    {
      label: 'User',
      key: 'user',
      localizeId: 'user',
    },
    {
      label: 'Time',
      key: 'timestamp',
      localizeId: 'time',
    },
    {
      label: 'Status',
      key: 'status',
      localizeId: 'status',
    },
  ],
}
